import http from './ApiConfig';
import { Service } from './Service';

export class LoginService extends Service {
  constructor() {
    super('login');
  }

  public logout() {
    return http.post(`${this._nomeControle}/logout`, null, this.GetHeader());
  }
}
